import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";
import { PanLinkResponse } from "../panService/getLink";

export async function getLinkFormalize(id: string, type: PartnerType) {
  const { data } = await httpClient.get<PanLinkResponse>(
    `/self-hire/transaction/${id}/link`,
    {
      params: {
        type,
      },
    }
  );
  return data;
}
